var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.982483 0.980957H15.0175V15.0172H0.982483V0.980957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5675 0.0585938H0.433748C0.227498 0.0585938 0.0599976 0.226094 0.0599976 0.432344V15.5661C0.0599976 15.7711 0.227498 15.9398 0.433748 15.9398H15.5675C15.7725 15.9398 15.9412 15.7711 15.9412 15.5661V0.432344C15.94 0.227344 15.7712 0.0585938 15.5675 0.0585938ZM15.0175 15.0173H0.982498V0.981094H15.0175V15.0173Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.515 4.3601L13.35 3.19385L6.13999 10.4738L2.64999 7.0051L1.48499 8.17135L6.14499 12.8051L6.88499 12.0651L6.88249 12.0613L14.515 4.3601Z",
    fill: "#ED6C30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox1);
export default __webpack_public_path__ + "static/media/checkbox1.c6bb7bc5611c2fac7a20c22216a8985e.svg";
export { ForwardRef as ReactComponent };